/**
 * Tên dự toán
 * NVTUYEN 25.05.2023
 */
export default {
  BuPlanExpenseBudget: 'Dự toán chi đầu năm theo MLNS',
  BuPlanExpenseBudgetAdd: 'Dự toán chi bổ sung theo MLNS',
  BuPlanExpenseBudgetSupplement: 'Dự toán chi điều chỉnh theo MLNS',
  BuPlanExpenseActivity343: 'Dự toán chi đầu năm theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanExpenseActivityAdd343: 'Dự toán chi bổ sung theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanExpenseActivitySupplement343: 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 343/2016/TT-BTC)',
  BuPlanExpenseActivity344: 'Dự toán chi đầu năm theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanExpenseActivityAdd344: 'Dự toán chi bổ sung theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanExpenseActivitySupplement344: 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 344/2016/TT-BTC)',
  BuPlanExpenseActivity342: 'Dự toán chi đầu năm theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  BuPlanExpenseActivityAdd342: 'Dự toán chi bổ sung theo NDKT (Mẫu TT 342/2016/TT-BTC)',
  BuPlanExpenseActivitySupplement342: 'Dự toán chi điều chỉnh theo NDKT (Mẫu TT 342/2016/TT-BTC)',
};
